import { Global } from "@emotion/react";

export const GlobalStyles = () => (
  <Global
    styles={`
      :root {
        --font-family: "Proxima Nova", "Helvetica Neue", sans-serif;
      }

      * {
        box-sizing: border-box;
      }

      html, body {
        margin: 0;
        padding: 0;
      }

      html {
        height: 100%;
      }

      body {
        min-height: 100%;
      }

      body {
        font-family: var(--font-family);
        width: 100%;
      }

      #app-root {
        position: relative;
        height: 100%;
        min-height: 100%;
        min-height: 100dvh;
        z-index: 1;
      }

      body {
        color: var(--readable-color-on-light, #343536);
        overflow-x: hidden;

        --transparent-gradient: linear-gradient(0deg, transparent, transparent);

        background-image:
          linear-gradient(
            var(--theme-background-color-opacity-85),
            var(--theme-background-color-opacity-90)
          ),
          var(--theme-background-image-url, ""),
          var(--theme-background-image-placeholder-url, var(--transparent-gradient));
        background-attachment: fixed;
        background-size: cover;

        &::before {
          content: "";
          position: fixed;
          z-index: 0;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          backdrop-filter: blur(0.125rem);
        }
      }

      .background-light {
        --readable-color: var(--readable-color-on-light, #343536);
      }

      .background-dark {
        --readable-color: var(--readable-color-on-dark, #FFFFFF);
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p {
        margin: 0;
      }

      @media screen and (-webkit-min-device-pixel-ratio: 2),
        screen and (min-resolution: 2dppx) {
        body {
          -moz-osx-font-smoothing: grayscale;
          -webkit-font-smoothing: antialiased;
        }
      }

      @media screen and (min-width: 50em) {
        :root {
          font-size: 115%;
        }
      }

      @media screen and (min-width: 70em) {
        :root {
          font-size: 130%;
        }
      }

      input, button, a {
        outline-color: var(--theme-foreground-color);
        // Disables delay on touch devices
        touch-action: manipulation;
      }
    `}
  />
);
